import { Component } from 'react'

import { Post } from './Post'
import { Pagination } from './Pagination'

export class Posts extends Component {

	render() {
		if ( ! this.props.isSearchingPosts || this.props.posts.posts.length ) {

            let loadingClass = this.props.isSearchingPosts ? 'bi-posts__list--loading' : ''
            
			return (
				<div className="bi-posts">
					
					<div className="bi-posts__container container container-normal">

						<div className={ `bi-posts__list row ${loadingClass}` }>
							{this.props.posts.posts.map((post, index) => {
								return (
									<Post post={ post } key={ index } />
								)
							})}
						</div>

						<Pagination 
							totalPages={ this.props.posts.max_num_pages } 
							currentPage={ this.props.paged } 
							currentCategory={ this.props.currentCategory }
							updatePage={ this.props.updatePage }
						/>
					</div>

				</div>
			)
		} else {
			return (
				<div className="bi-posts">
					<div className="bi-posts__loader"></div>
				</div>
			)
		}
	}

}